const PbxxRecord = require('../pbxx_record')

module.exports = class Brand extends PbxxRecord {
  static get class_name() {
    return 'Brand'
  }

  accept_all_brand_requests() {
    return this._mapper().accept_all_brand_requests(this.id).then((response) => {
      return this
    }, (error) => {
      throw(error)
    })
  }

  revoke_all_brand_requests() {
    return this._mapper().revoke_all_brand_requests(this.id).then((response) => {
      return this
    }, (error) => {
      throw(error)
    })
  }

  reaccept_all_brand_requests() {
    return this._mapper().reaccept_all_brand_requests(this.id).then((response) => {
      return this
    }, (error) => {
      throw(error)
    })
  }

}
